import request from '@/utils/request'

export function fetchNoticeList (query) {
  return request({
    url: '/auth/api/notice/index',
    method: 'get',
    params: query
  })
}

export function fetchNotice (id) {
  return request({
    url: '/auth/api/notice/view',
    method: 'get',
    params: { id }
  })
}

export function createNotice (data) {
  return request({
    url: '/auth/api/notice/insert',
    method: 'post',
    data
  })
}

export function updateNotice (data) {
  return request({
    url: '/auth/api/notice/update',
    method: 'post',
    data
  })
}

export function deleteNotice (id) {
  return request({
    url: '/auth/api/notice/delete',
    method: 'post',
    params: { id }
  })
}

export function getCountNotice () {
  return request({
    url: '/auth/api/notice/count',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/notice.js